module.exports = __webpack_public_path__ + "static/media/16UNODC20.3a171787.jpg";